(function () {
  var scheduled = false;
  var observed = new WeakSet();
  var observer = new ResizeObserver(schedule);
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(align);
  }
  function align() {
    scheduled = false;
    document.querySelectorAll('#site-main .productgrid--items').forEach(function (grid) {
      if (!observed.has(grid)) { observed.add(grid); observer.observe(grid); }
      var rows = new Map();
      var listView = !!grid.closest('.productgrid-listview') || grid.classList.contains('lnw-search-list');
      Array.from(grid.children).forEach(function (card) {
        var title = card.querySelector('.productitem--title');
        var link = title && title.querySelector('a');
        if (!link || !card.getBoundingClientRect().width) return;
        if (listView) { title.style.removeProperty('--lnw-card-title-height'); return; }
        var row = Math.round(card.getBoundingClientRect().top / 2);
        if (!rows.has(row)) rows.set(row, []);
        rows.get(row).push({title: title, height: Math.ceil(link.getBoundingClientRect().height)});
      });
      rows.forEach(function (cards) {
        var height = Math.max.apply(null, [42].concat(cards.map(function (card) { return card.height; }))) + 'px';
        cards.forEach(function (card) {
          if (card.title.style.getPropertyValue('--lnw-card-title-height') !== height) card.title.style.setProperty('--lnw-card-title-height', height);
        });
      });
    });
  }
  function start() {
    var main = document.getElementById('site-main');
    if (!main) return;
    new MutationObserver(schedule).observe(main, {childList: true, subtree: true});
    main.addEventListener('load', schedule, true);
    window.addEventListener('resize', schedule, {passive: true});
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
}());
